import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  Button,
  InputAdornment,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import MUITable from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { IUser } from '../../context/AuthContext';
import Row from './components/Row';
import s from './styles.module.scss';
import { TableData, UserGetData } from './types';
import createData from './utils/create-data';

const UsersTable = ({ data, loggedUser }: { data: UserGetData[]; loggedUser: IUser }) => {
  const [searchText, setSearchText] = useState('');
  const rows: TableData[] = [];

  data.forEach((item: UserGetData) => {
    if (item.id === loggedUser.id) {
      return; // if the user id matches user logged in do not push
    }
    rows.push(createData(item.id, `${item.firstName} ${item.lastName}`, item.email, item.blacklisted));
  });

  const filteredRows = useMemo(() => {
    const normalizedSearch = searchText.trim().toLowerCase();
    const baseRows = [...rows].sort((a, b) => a.name.localeCompare(b.name));

    if (!normalizedSearch) return baseRows;

    return baseRows.filter(
      (row) => row.name.toLowerCase().includes(normalizedSearch) || row.email.toLowerCase().includes(normalizedSearch)
    );
  }, [rows, searchText]);

  return (
    <TableContainer className={s.container}>
      <Box sx={{ px: 2, pt: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        <Typography variant='subtitle1' sx={{ fontWeight: 700, color: '#1b3f82' }}>
          Users ({filteredRows.length})
        </Typography>
        <TextField
          size='small'
          placeholder='Search users'
          value={searchText}
          onChange={(event) => setSearchText(event.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon fontSize='small' />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <MUITable>
        <TableHead className={s.header}>
          <TableRow>
            <TableCell className={s.cell}>Name</TableCell>
            <TableCell className={s.cell}>Email</TableCell>
            <TableCell className={s.cell}>Access</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredRows.map((row) => (
            <Row key={row.id} data={row} />
          ))}
        </TableBody>
      </MUITable>
      {loggedUser.permissions[loggedUser.currentClient.client.name].includes('users-create') ? (
        <Box className={s.bottom}>
          <Link to='/users/add' style={{ textDecoration: 'none' }}>
            <Button variant='contained' sx={{ alignSelf: 'flex-start' }}>
              Add User
            </Button>
          </Link>
        </Box>
      ) : null}
    </TableContainer>
  );
};

export default UsersTable;
